import { TinyColor } from '@eigtech/ui-shared-color'

let context: CanvasRenderingContext2D | null | undefined

/**
 * Normalize any CSS color to a TinyColor.
 *
 * TinyColor handles hex, rgb, hsl and named colors on its own, but not the modern
 * color spaces (`oklch()`, `lab()`, …) the white label theme may be served in. Those
 * are parsed by handing them to a canvas and reading the painted pixel back, which
 * uses the browser's own CSS color parser.
 *
 * @returns undefined when the color is missing or cannot be parsed
 */
export function toTinyColor(color: string | undefined): TinyColor | undefined {
  if (!color) return undefined

  const direct = new TinyColor(color)
  if (direct.isValid) return direct

  if (context === undefined) context = document.createElement('canvas').getContext('2d')
  if (!context) return undefined

  // Assigning an invalid color leaves fillStyle at its previous value, so seed it
  // with a transparent one and treat a zero alpha readback as "unparseable".
  context.fillStyle = 'transparent'
  context.fillStyle = color
  context.clearRect(0, 0, 1, 1)
  context.fillRect(0, 0, 1, 1)

  const [r, g, b, a] = context.getImageData(0, 0, 1, 1).data

  return a === 0 ? undefined : new TinyColor({ r, g, b })
}
